import { render, staticRenderFns } from "./SelecionarUsuarioPedido.vue?vue&type=template&id=3ff5bd1a&"
import script from "./SelecionarUsuarioPedido.vue?vue&type=script&lang=js&"
export * from "./SelecionarUsuarioPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports